export default __webpack_public_path__ + "static/2-0-0-0-c09579524138d24fd23122fe24b2b840.jpg";